import { AppFrame } from "./Ui";

import { useState, useEffect, useRef } from "react";
import "./App.css";
import { db, auth } from "./Firebase";
import { signOut as firebaseSignOut } from "firebase/auth";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Redesign.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  query,
  where,
} from "./leagueStore";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Routes,
} from "react-router-dom";
import { signInWithGoogle } from "./Firebase";
import TeamSelection from "./pages/TeamSelection";
import Pickem from "./pages/Pickem";
import PowerRanking from "./pages/PowerRanking";
import KeeperSelection from "./pages/KeeperSelection";
import Stats from "./pages/Stats";
import Home from "./pages/Home";
import { gsap } from "gsap";
import { week1StartUnixMs } from "./season";
import {
  isPassedDue as weekLockIsPassedDue,
  WEEK_LENGTH_MS,
} from "./rules/weekLock";

export { WEEK_LENGTH_MS };

/** Entries close Thursday at 7:30 p.m. America/Chicago for the requested week. */
export function isPassedDue(week) {
  let w = week;
  if (w < 1) w = 1;
  return weekLockIsPassedDue(Date.now(), w, week1StartUnixMs);
}

/** Shared lock for current getWeek() — call as passedDue(). */
export function passedDue() {
  return isPassedDue(getWeek());
}

export const usersReference = collection(db, "Users");
// export const usersReference = collection(db, "UsersTest");
export const picksReference = collection(db, "Picks");
// export const picksReference = collection(db, "PicksTest");
export const rankingsReference = collection(db, "Rankings");
// export const rankingsReference = collection(db, "RankingsTest");
export const keepersReference = collection(db, "Keepers");
export const messagesReference = collection(db, "Messages");
export const winnersReference = collection(db, "Winners");
export const generalReference = collection(db, "General");
export const challengesReference = collection(db, "Challenges");
export {
  currYear,
  leagueId,
  leagueSize,
  week1StartUnixMs,
  waitingOnDraftMessage,
  keepersNotPostedMessage,
} from "./season";
export const tbMessage = [
  "NONE",
  "How many points will the highest scoring QB put up?", // 1
  "How many points will the highest scoring RB put up?", // 2
  "How many points will the highest scoring WR put up?", // 3
  "How many points will the highest scoring TE put up?", // 4
  "How many points will the highest scoring D/ST put up?", // 5
  "How many points will the highest scoring K put up?", // 6 
  "How many points will the highest scoring bench player put up?", // 7
  "How many points will the highest scoring fantasy team put up?", // 8 
  "How many points will the lowest scoring fantasy team put up?", // 9 
  "How many yards will be the longest touchdown of the week", // 10
  "What will be the difference in points scored in the biggest fantasy blowout this week?", // 11
  "What will be the difference in points scored in the closest fantasy matchup this week?", // 12
  "How many points will the highest scoring NFL team put up?", // 13
  "What will be the difference in points scored in the biggest NFL blowout this week?", // 14
  "What will be the difference in points scored in the closest NFL matchup this week?", // 15
  "What is the most amount of receptions an RB will have this week?", // 16
  "What is the most amount of receptions a WR will have this week?" , // 17
]; //my league
export const sleep = (ms) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

export const updateUser = async (id, tid) => {
  const userDoc = doc(db, "Users", id);
  // const userDoc = doc(db, "UsersTest", id);
  const newFields = { id: tid };
  await updateDoc(userDoc, newFields);
};

export const getId = async (ref) => {
  let q = query(ref, where("Email", "==", localStorage.getItem("email")));
  const data = await getDocs(q);

  if (!data.empty) {
    return data.docs[0]._document.data.value.mapValue.fields.id.stringValue;
  } else {
    return -1;
  }
};

export const getWeek = () => {
  let w1 = week1StartUnixMs;
  let weekTime = 604800000;

  //week starts
  //1 - 1662518523776
  //2 - 1663123323776
  //3 - 1663728123776

  //distance between now and start of w1 = length of week * x
  let weeksPassed = (Date.now() - w1) / weekTime;
  // console.log('Date.now(): ' + Date.now())

  // Define the target date and current date
var targetDate = new Date("2023-09-05T06:00:00");
var currentDate = new Date();

// Calculate the difference in milliseconds
var timeDifference = targetDate - currentDate;

// console.log(timeDifference); // This will output the time difference in milliseconds
// return 10;
  if (weeksPassed < 1) {
    return 1;
  } else {
    return Math.floor(weeksPassed + 1)%52;
  }
  // return 3
};


function App() {
  const [authError, setAuthError] = useState("");
  async function signOut() {
    try { await firebaseSignOut(auth); }
    catch { setAuthError("Could not sign out. Please try again."); return; }
    localStorage.removeItem("name");
    localStorage.removeItem("email");
    localStorage.removeItem("userId");
    window.location.assign("/");
  }
  async function signIn() {
    setAuthError("");
    try {
      await signInWithGoogle();
      const email = localStorage.getItem("email");
      if (!email) return;
      const data = await getDocs(query(usersReference, where("Email", "==", email)));
      if (data.empty) {
        await addDoc(usersReference, { id: "", Name: localStorage.getItem("name"), Email: email });
        localStorage.setItem("userId", "");
      } else {
        const existing = data.docs.find(d => d.data().id) || data.docs[0];
        localStorage.setItem("userId", existing.data().id || "");
      }
      window.location.assign("/");
    } catch (error) {
      setAuthError(error.message || "Could not sign in. Please try again.");
    }
  }
  return <Router><AppFrame onSignIn={signIn} onSignOut={signOut} authError={authError}>
    <Routes>
      <Route path="/" element={<Home onSignIn={signIn}/>} />
      <Route path="/pickem" element={<Pickem/>} />
      <Route path="/powerranking" element={<PowerRanking/>} />
      <Route path="/keeperselection" element={<KeeperSelection/>} />
      <Route path="/teamselection" element={<TeamSelection/>} />
      <Route path="/stats" element={<Stats onSignIn={signIn}/>} />
      <Route path="*" element={<div className="empty-state"><h1>Page not found</h1><Link to="/">Back to the league</Link></div>}/>
    </Routes>
  </AppFrame></Router>;
}
export default App;
